OT.createNS('OT.Autocomplete');

var search;

OT.Autocomplete.searchPathHandler = function searchPathHandler() {
  return window.location.pathname;
};

OT.Autocomplete.buildOnSubmit = function buildOnSubmit() {
  return function onSubmit(submission) {
    if (submission.resultType === 'cuisine') {
      OT.Search.Params.set({ Term: null });
      OTSearchBundle.selectCuisine(submission.query.cuisineIds);
    } else {
      window.location.href = submission.url;
    }
  };
};

// .covers, .datetime, .searchText (ignored)
OT.Autocomplete.updatedSearchParameters = {};

OT.Events.on("dtp:change", function(_, data) {
  OT.Autocomplete.updatedSearchParameters = data;
});

OT.Autocomplete.argsBuilder = function legacyArgs(dtp, model) {
  var metroId = model.Request.MetroId;
  var QueryCenter = model.Results.QueryCenter;
  var currentLocationName = null;

  var selectedRegion = _.find(model.Filters.Regions, function(region) {
    return region.IsSelected;
  });

  if (selectedRegion) {
    currentLocationName = selectedRegion.Name;
  } else if (OTSearchData.Display.Metro) {
    currentLocationName = OTSearchData.Display.Metro.Name;
  }

  return {
    initialTerm: model.Request.Term,
    addressLocationFallback: false,
    addressMapRedirect: false,
    allRestaurantsIcon: -1,
    areaIdToParse: undefined,
    clearInputOnFocus: false,
    currentLocationName: currentLocationName,
    covers: dtp.covers,
    dateTime: dtp.datetime,
    disableFreetext: false,
    freetextAsync: true,
    disableAllRestaurants: true,
    disableAddresses: false,
    disableLanguageInPath: true,
    disableRecentPlaceholder: true,
    disableCuisines: false,
    domainId: model.DomainInfo.id,
    domainWhitelist: model.DomainWhitelist,
    language: model.DomainCulture.Culture,
    latitude: QueryCenter ? model.Results.QueryCenter.latitude : undefined,
    legacy: true,
    locationFormat: model.Experiments.gpt173 ? 'C' : undefined,
    longitude: QueryCenter ? model.Results.QueryCenter.longitude : undefined,
    metroId: metroId,
    onSelect: function onSelect(data) {
      if (data) {
        OT.Autocomplete.submit({
          covers: OT.Autocomplete.updatedSearchParameters.covers,
          datetime: OT.Autocomplete.updatedSearchParameters.datetime
        });
      }
    },
    onSubmit: OT.Autocomplete.buildOnSubmit(model),
    personalizer: true,
    redirectSingleToMulti: true,
    restaurantLocationName: model.Experiments.gpt173 ? 'N,MN,C' : undefined,
    resultsLimit: null,
    searchPathHandler: OT.Autocomplete.searchPathHandler,
    secondaryResultsLimit: null,
    selector: '#dtp-search-single-box',
    showAddressesToolTip: false
  };
};

OT.Autocomplete.submit = function submit(dtp) {
  var model = OTSearchData;
  var lower = {};

  _.each(model.Request, function(value, key) {
    lower[key.toLowerCase()] = value;
  });

  var searchObj = OT.Search.Helpers.buildSearchParameters.addKnownKeysIfDefined(
    lower,
    OT.Search.Helpers.buildSearchParameters.requestKeys,
    true
  );

  search.submit({
    dtp: dtp,
    location: {
      metroId: model.Request.MetroId,
      regionId: model.Request.RegionIds,
      neighborhoodId: model.Request.NeighborhoodIds,
      areaId: model.Request.AreaId,
      latitude: model.Request.Latitude,
      longitude: model.Request.Longitude
    },
    search: searchObj
  });
};

OT.Autocomplete.init = function init() {
  var self = this;

  OT.Events.on('dtp:rendered', function(e, dtp) {
    var res = OT.Autocomplete.argsBuilder(dtp, OTSearchData);
    search = OTAutocomplete.init(res);

    OT.Events.on('dtp:search', function(e, dtp) {
      OT.Autocomplete.submit(dtp);
    });
  });
};
